var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"event-personal-slashie"}},[_c('PsEventHeader'),_c('PsEventMain'),_c('PsEventTA'),_c('PsEventProduct'),_c('PsEventPricing'),_c('PsEventApply'),_c('PsEventFaq'),_c('PsEventFooter'),_c('PsEventModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }